// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingPackageGroupPriceListResponse

import { hydrateBillingPackageGroupPrice, type BillingPackageGroupPrice, type BillingPackageGroupPriceApiResponse } from './billingPackageGroupPrice.gen';

export type BillingPackageGroupPriceListApiResponse = {
	items: BillingPackageGroupPriceApiResponse[];
};

export type BillingPackageGroupPriceList = {
	items: BillingPackageGroupPrice[];
};

export function hydrateBillingPackageGroupPriceList(data: BillingPackageGroupPriceListApiResponse): BillingPackageGroupPriceList {
	return {
		...data,
		items: data.items.map(hydrateBillingPackageGroupPrice),
	};
}